"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postCoreDataSecurityMonitoredObjectsSlice = void 0;
const get_1 = require("./get.js");
const get_2 = require("../usage/get.js");
const data_security_1 = require("../../../api/data-security/index.js");
const xuder_1 = require("@sonar-software/xuder");
exports.postCoreDataSecurityMonitoredObjectsSlice = (0, xuder_1.createPostAsyncSlice)({
    httpSagaOptions: {
        successActionCreators: [
            get_1.getCoreDataSecurityMonitoredObjectsSlice.asyncActionCreators.repeatGetCoreDataSecurityMonitoredObjects,
            get_2.getCoreDataSecurityUsageSlice.asyncActionCreators.repeatGetCoreDataSecurityUsage
        ]
    },
    name: 'CoreDataSecurityMonitoredObjects',
    receive: false,
    request: true,
    requestHandler: data_security_1.postDataSecurityMonitoredObjects,
    yieldType: xuder_1.SagaYieldType.Latest
});
//# sourceMappingURL=post.js.map